import { ICountriesState } from './state';

export function flags(state) {
  return state.flags;
}

export function getAbsolutePath(state: ICountriesState) {
  // @TODO: move path to .env
  return function (countryName: string) {
    const flag = state.flags.find((flag) => flag.name == countryName)!.flag;
    /**
     * @TODO: si no tiene una bandera definida el país no se muestra en los destinations
     */
    return 'https://advanced.travellyze.com/images/flags/' + flag + '.svg';
  };
}
